export default function NotFound() {
  return (
    <div className="container text-center">
      <h1>Not Found</h1>
      <p>Are you where you want to be?</p>
      <p className="mt-5">But really, this is a 404 error. There's no page at this URL.</p>
    </div>
  );
}
